export default __webpack_public_path__ + "static/media/element_60.47d4bcc4.jpg";